import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function VolumesDetail() {
  const fisicaVols = [{
    vol: '⚡ Vol. 1 — 1° Año',
    content: 'El Mundo Físico: medición, movimiento y fuerzas'
  }, {
    vol: '⚡ Vol. 2 — 2° Año',
    content: 'Energía, Trabajo y Calor'
  }, {
    vol: '⚡ Vol. 3 — 3° Año',
    content: 'Ondas, Sonido y Luz'
  }, {
    vol: '⚡ Vol. 4 — 4° Año',
    content: 'Electricidad y Magnetismo'
  }, {
    vol: '⚡ Vol. 5 — 5° Año',
    content: 'Física Moderna e Introducción Cuántica'
  }, {
    vol: '⚡ Vol. 6 — 6° Año',
    content: 'Física Aplicada: Tecnología y Sociedad'
  }];
  const quimicaVols = [{
    vol: '🧪 Vol. 1 — 1° Año',
    content: 'Materia, Mezclas y Primeras Reacciones'
  }, {
    vol: '🧪 Vol. 2 — 2° Año',
    content: 'Estructura Atómica y Tabla Periódica'
  }, {
    vol: '🧪 Vol. 3 — 3° Año',
    content: 'Enlace Químico y Propiedades'
  }, {
    vol: '🧪 Vol. 4 — 4° Año',
    content: 'Reacciones Químicas y Estequiometría'
  }, {
    vol: '🧪 Vol. 5 — 5° Año',
    content: 'Química Orgánica e Introducción Bioquímica'
  }, {
    vol: '🧪 Vol. 6 — 6° Año',
    content: 'Química Ambiental y Aplicaciones Tecnológicas'
  }];
  const includes = ['Planificación anual lista para la carpeta docente', 'Guion de clase completo (inicio–desarrollo–cierre)', 'Actividades concretas sin instrumentos caros', 'Rúbricas y evidencias de evaluación incluidas', 'Proyectos integradores por unidad', 'Efemérides argentinas integradas por grado y año'];
  const bookEmojis = ['📘', '📗', '📕', '📙', '📘', '📙'];
  const formatVolText = (volText: string) => {
    // Replace "⚡ Vol." or "🧪 Vol." with "Tomo" and append ":"
    return volText.replace(/^[⚡🧪]\s*Vol\./, 'Tomo') + ':';
  };
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border" data-id="element-311">
      <div className="max-w-5xl mx-auto" data-id="element-312">
        <motion.h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-313">
          Lo que <span className="text-[#00FF84]" data-id="element-314">recibís</span>
        </motion.h2>

        <div className="max-w-2xl mx-auto flex flex-col gap-8 mb-20" data-id="element-315">
          {/* Física Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-card border border-[#C8A200] rounded-2xl p-6 md:p-8" data-id="element-316">
            <div className="mb-6" data-id="element-317">
              <h3 className="text-xl md:text-2xl font-heading font-bold uppercase mb-1 text-[#00FF84]" data-id="element-318">
                ⚡ FÍSICA — 6 Tomos
              </h3>
              <p className="text-white/60 text-sm" data-id="element-319">
                Para docentes de Física de 1° a 6° año de secundaria
              </p>
            </div>

            <div className="space-y-5" data-id="element-320">
              {fisicaVols.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-321">
                  <span className="text-xl leading-none mt-0.5" data-id="element-322">
                    {bookEmojis[i]}
                  </span>
                  <p className="text-white/90 text-base leading-relaxed" data-id="element-323">
                    <span className="font-bold text-white mr-1" data-id="element-324">
                      {formatVolText(item.vol)}
                    </span>
                    {item.content}
                  </p>
                </div>)}
            </div>
          </motion.div>

          {/* Química Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-card border border-[#C8A200] rounded-2xl p-6 md:p-8" data-id="element-325">
            <div className="mb-6" data-id="element-326">
              <h3 className="text-xl md:text-2xl font-heading font-bold uppercase mb-1 text-[#00FF84]" data-id="element-327">
                🧪 QUÍMICA — 6 Tomos
              </h3>
              <p className="text-white/60 text-sm" data-id="element-328">
                Para docentes de Química de 1° a 6° año de secundaria
              </p>
            </div>

            <div className="space-y-5" data-id="element-329">
              {quimicaVols.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-330">
                  <span className="text-xl leading-none mt-0.5" data-id="element-331">
                    {bookEmojis[i]}
                  </span>
                  <p className="text-white/90 text-base leading-relaxed" data-id="element-332">
                    <span className="font-bold text-white mr-1" data-id="element-333">
                      {formatVolText(item.vol)}
                    </span>
                    {item.content}
                  </p>
                </div>)}
            </div>
          </motion.div>
        </div>

        {/* Cada volumen incluye */}
        <motion.div className="max-w-2xl mx-auto bg-brand-card rounded-2xl p-8 md:p-12 border-2 border-[#C8A200]" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-334">
          <h3 className="text-2xl md:text-3xl font-heading font-bold mb-8 md:mb-10 text-center text-[#00FF84]" data-id="element-335">
            Cada tomo incluye:
          </h3>

          <div className="flex flex-col gap-5 md:gap-6" data-id="element-336">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-337">
                <div className="flex-shrink-0 w-8 h-8 bg-[#4CAF50] rounded-md flex items-center justify-center mt-0.5" data-id="element-338">
                  <Check className="text-white" size={20} strokeWidth={3} data-id="element-339" />
                </div>
                <span className="font-bold text-white text-lg md:text-xl leading-snug" data-id="element-340">
                  {item}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}